import Input from "./Input";
import RadioGroup from "./RadioGroup";
import Select from "./Select";
import Checkbox from "./Checkbox";
import DatePicker from "./DatePicker";
import ButtonColor from "./ButtonColor";
import ButtonDanger from "./ButtonDanger";
import ActionButton from "./ActionButton";

const Controls = {
    Input,
    RadioGroup,
    Select,
    Checkbox,
    DatePicker,
    ButtonColor,
    ButtonDanger,
    ActionButton
}

export default Controls;